import { DOCS_FORM_NAMES } from "core/consts";
import { FormFieldConfigFactory } from "../..";
import { createEntDischargeLetterPdf } from "./pdfCreator";
import { DischargeLetterENTFormSchema } from "./schema";
import { DischargeLetterENTFormSections } from "./sections";

export const getDischargeLetterENTFormConfig: FormFieldConfigFactory<
  typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_ENT
> = () => {
  return {
    config: { canPrint: false, canSendToHis: false },
    getInitialValue: ({ value }) => {
      return {
        additional_findings: value?.additional_findings ?? "",
        admission_medications: value?.admission_medications ?? "",
        anamnesis: value?.anamnesis ?? "",
        clinical_course: value?.clinical_course ?? "",
        diagnoses: value?.diagnoses ?? "",
        discharge_medications: value?.discharge_medications ?? "",
        findings: value?.findings ?? "",
        laboratory_parameters: value?.laboratory_parameters ?? "",
        recommendations: value?.recommendations ?? "",
        secondary_diagnoses: value?.secondary_diagnoses ?? "",
        therapy: value?.therapy ?? "",
      };
    },
    header: ({ translations }) =>
      translations.extractDocs.dischargeLetter.formEnt.title,
    pdfConfig: {
      pdfCreator: createEntDischargeLetterPdf,
    },
    schema: DischargeLetterENTFormSchema,
    sections: DischargeLetterENTFormSections,
  };
};
